<template>
  <base-slide-over ref="slideOver" title="Send Invitation">
    <base-form class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" ref="form" v-model="isFormValid">
      <base-select
        label="Location"
        placeholder="Select a location"
        :optgroups="locationOptGroups"
        v-model="selectedLocationId"
        label-key="name"
        value-key="businessLocationId"
        required
      />
      <base-checkbox-group required v-model="communications">
        <base-checkbox value="email" v-model="communications">
          <div class="tw-font-normal">Send Email</div>
          <div class="tw-text-xs tw-text-gray-500">{{ email }}</div>
        </base-checkbox>
        <base-checkbox value="text" v-model="communications" class="tw-mt-4">
          <div class="tw-font-normal">Send Text Message</div>
          <base-phone-number-field :value="phone" class="tw-text-xs tw-text-gray-500" />
        </base-checkbox>
      </base-checkbox-group>
    </base-form>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="$refs.slideOver.hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="sendInvite" :disabled="!isFormValid" :loading="isLoading">Invite Member</base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { STATE_OPTIONS } from "@/constants/constants";
import { mapGetters } from "vuex";

export default {
  props: {
    businessId: { type: String, required: true },
    userId: { type: String, required: true },
    email: String,
    phone: String,
    fullName: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      selectedLocationId: null,
      communications: [],
    };
  },
  computed: {
    ...mapGetters("location", ["location", "locations"]),
    locationOptGroups() {
      return STATE_OPTIONS.filter((s) => this.locations.find((l) => l.state === s.value)).map((s) => ({
        label: s.value,
        options: this.locations.filter((l) => l.state === s.value),
      }));
    },
  },
  methods: {
    show() {
      this.$refs.slideOver.show();
    },
    hide() {
      this.$refs.slideOver.hide();
    },
    async sendInvite() {
      if (!this.$refs.form.validate()) return;
      try {
        this.isLoading = true;
        await this.$axios.post(`/businesses/${this.businessId}/invite`, {
          email: this.communications.includes("email") ? this.email : null,
          phone: this.communications.includes("text") ? this.phone : null,
          locationId: this.selectedLocationId,
          userId: this.userId,
          fullName: this.fullName,
        });
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Invitation Sent", message: "Your invitation was sent successfully" });
        this.hide();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Error sending invite",
          message: "There was an error sending the invite. There may have been a connection error. Please reload the page to try again.",
          error,
        });
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
